import { Center, Group, RingProgress, Text } from '@mantine/core';
import { IconRobot, IconScan, IconSearch } from '@tabler/icons';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import classes from './textDot.module.css';

// export const TextDot = () => {
//   return <span className={classes.dot} />;
// };

export const TextDot = () => {
  const { t } = useTranslation();
  const [index, setIndex] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      index < 2 && setIndex((_) => _ + 1);
    }, 2000);

    return () => {
      clearInterval(interval);
    };
  }, [index]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (progress < 92) {
        setProgress((_) => _ + 1);
      }
    }, 60);

    return () => {
      clearInterval(interval);
    };
  }, [progress]);

  const text = useMemo(() => t(`completions.think_step.step${index + 1}`), [index, t]);

  return (
    <Group gap="xs" className="overflow-hidden">
      <RingProgress
        size={28}
        thickness={2}
        roundCaps
        sections={[{ value: progress, color: 'violet' }]}
        label={
          <Center className="text-violet-700">
            {index === 0 && <IconScan size={14} className="animate-pulse" />}
            {index === 1 && <IconSearch size={14} className="animate-pulse" />}
            {index === 2 && <IconRobot size={14} className="animate-pulse" />}
          </Center>
        }
      />
      <Text size="sm" className="animate-pulse">
        {text}
      </Text>
    </Group>
  );
};
